import { Component, ElementRef, ViewChild, Inject, OnInit } from '@angular/core';
import {
  IReportEmbedConfiguration,
  models,
  service,
} from 'powerbi-client';

import { PowerBIReportEmbedComponent } from 'powerbi-client-angular';
import { HttpClient } from '@angular/common/http';

import { PowerBIService } from 'app/services/powerbi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { relative } from 'path';
import * as pbi from 'powerbi-client';
import { UtilityServiceService } from 'app/services/utility-service.service';


@Component({
  selector: 'app-carrier-reports',
  templateUrl: './carrier-reports.component.html',
  styleUrls: ['./carrier-reports.component.scss']
})
export class CarrierReportsComponent implements OnInit {
  @ViewChild(PowerBIReportEmbedComponent)
  reportObj!: PowerBIReportEmbedComponent;
  @ViewChild('powerbiReport', { static: false }) powerbiReport: PowerBIReportEmbedComponent;
  phasedEmbeddingFlag = false;
  isEmbedded = false;
  displayMessage = 'Please wait while your report is being fetched.';
  reportClass = 'is-embedded report-container';
  carrierCode;
  reportprint:any;
  reportIds: Report[] = [];
  selectedReportId: any | undefined;
  reportConfig: IReportEmbedConfiguration = {
    type: 'report',
    tokenType: models.TokenType.Embed,
    permissions: models.Permissions.Read,
  };

  eventHandlersMap = new Map<string, (event?: service.ICustomEvent<any>) => void>([
    ['loaded', () => {
      this.isEmbedded = true;
      console.log('Report has loaded.');
    }],
    ['rendered', () => console.log('Report has rendered')],
    ['error', (event?: service.ICustomEvent<any>) => {
      if (event) {
        console.error(event.detail);
      }
    }],
    ['visualClicked', () => console.log('Visual clicked')],
    ['pageChanged', (event) => console.log(event)]
  ]);

  constructor(
    public http: HttpClient,private _activatedRoute: ActivatedRoute,private router: Router,
    public powerBIService: PowerBIService,public utility: UtilityServiceService
  ) {}

  ngOnInit(): void {
    this.carrierCode = this._activatedRoute.snapshot.paramMap.get("id");
    this.loadReportIds();
    // this.embedReport();
  }
  onReportSelectionChange(reportId: string): void {
    if (reportId) {
      console.log('Selected Report ID:', reportId);
      this.selectedReportId = reportId;
      this.embedReport();
    }
  }
  
  onBack() {
    this.router.navigateByUrl("carrier/accounts");
  }
  
  loadReportIds(): void {
    this.powerBIService.getReportIds()
      .subscribe(
        (data: Report[]) => {
          this.reportIds = data;
          console.log("data stuff",data)
          this.selectedReportId = data.length > 0 ? data[0] : undefined;
          this.onReportSelectionChange(this.selectedReportId);
        },
        (error) => {
          console.error('Error fetching report IDs:', error);
        }
      );
  }
  
  printReport(): void {
    this.reportObj.getReport().fullscreen(); // View the report in fullscreen
    this.reportObj.getReport().print(); // Print the report
  }
  
  printFullReport(): void {
    const printWindow = window.open('', '', 'width=800,height=600');
    const reportContainer = document.querySelector('.report-container');
  
    if (printWindow && reportContainer) {
      printWindow.document.open();
      printWindow.document.write('<html><head><title>Print Report</title></head><body>');
      printWindow.document.write('<style>@media print{.report-container{width: 100%; height: auto;}}</style>');
      printWindow.document.write(reportContainer.innerHTML);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
      printWindow.close();
    }
  }
  
  

  async embedReport(): Promise<void> {
    try {
      const result = await this.powerBIService.getWithCarrierCodeReportId(this.carrierCode, this.selectedReportId).toPromise();
      const embedParams = result as EmbedParams;
  console.log("embed params",embedParams)
      this.reportConfig = {
        ...this.reportConfig,
        id: embedParams.EmbedReport[0].ReportId,
        embedUrl: embedParams.EmbedReport[0].EmbedUrl,
        accessToken: embedParams.EmbedToken.Token,
        settings: {
          
          filterPaneEnabled: false,
          navContentPaneEnabled: true,
          layoutType: models.LayoutType.Custom,
          customLayout: {
            displayOption: models.DisplayOption.ActualSize
          }
          
          
        }
      };
     // this.reportObj.getReport().print();
    } catch (error: any) {
      console.error('Error while fetching the report:', error);
      this.displayMessage = `Failed to fetch config for report. Status: ${error.statusText} Status Code: ${error.status}`;
      console.error(this.displayMessage);
      return;
    }
  }
  


}

interface EmbedConfig {
  type: string;
  id: string;
  embedUrl: string;
  accessToken: string;
  tokenType: string;
}

interface EmbedParams {
  Type: string;
  EmbedReport: {
    ReportId: string;
    ReportName: string;
    EmbedUrl: string;
  }[];
  EmbedToken: {
    Token: string;
    TokenId: string;
    Expiration: string;
  };
}
interface Report {
  ReportId: string;
  ReportName: string;
  EmbedUrl: string;
}
enum PageNavigationPosition {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom'
}






